export const ARROW_LABEL_MAX_LENGTH = 200

// A new label starts in the middle of its line.
export const ARROW_LABEL_DEFAULT_POSITION = 0.5

// Pointer travel, in screen pixels, that turns a press on the label into a drag.
export const ARROW_LABEL_DRAG_THRESHOLD = 4

// Step, in line units, of the search for the point closest to the pointer.
export const ARROW_LABEL_SEARCH_STEP = 8

// Hint in an empty field; it also gives the empty plate its width.
export const ARROW_LABEL_PLACEHOLDER = 'Label'
